<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 12 12" :class="[`${prefix}-icon`, `${prefix}-icon-addFill`]" width="1em" height="1em" v-bind="$attrs"><path d="M6,0C2.68629,0,0,2.68629,0,6C0,9.31371,2.68629,12,6,12C9.31371,12,12,9.31371,12,6C12,2.68629,9.31371,0,6,0ZM9.61873,6C9.61777,6.3247,9.35479,6.58767,9.0301,6.58863L6.58863,6.58863L6.58863,9.0301C6.58767,9.3548,6.3247,9.61777,6,9.61873C5.67531,9.61777,5.41233,9.3548,5.41137,9.0301L5.41137,6.58863L2.9699,6.58863C2.64521,6.58767,2.38223,6.32469,2.38127,6C2.38223,5.67531,2.64521,5.41233,2.9699,5.41137L5.41137,5.41137L5.41137,2.9699C5.41233,2.64521,5.67531,2.38223,6,2.38127C6.32469,2.38223,6.58767,2.64521,6.58863,2.9699L6.58863,5.41137L9.0301,5.41137C9.3548,5.41233,9.61777,5.67531,9.61873,6Z"/></svg>
</template>
<script>

export default {
  name: 'IconAddFill',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
